import type { JSX } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export interface TextFilterProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string | undefined) => void;
}

export function TextFilter({ id, label, value, onChange }: TextFilterProps): JSX.Element {
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        value={value}
        aria-label={`Filter by ${label}`}
        placeholder={`Filter ${label.toLowerCase()}...`}
        onChange={(event) => onChange(event.target.value || undefined)}
        className="w-full sm:w-[180px]"
      />
    </div>
  );
}
